<template>
  <div
    :class="'pollContainer'+(isActive == true ? ' active' : '')+ (isEmbedded == true ? ' embedded' : '')"
    ref="pollContainer"
  >
    <div class="pollInnerContainer" ref="videoSwipeContainer">
      <div
        class="loadingContainer"
        :style="dataLoaded == false ? 'display:flex' : 'display:none'"
      >
        <div class="loader"></div>
        <div class="loadingText">{{$t('Loading Poll...')}}</div>
      </div>
      <div class="pollHeader">{{$t('Interactive polling')}}</div>
      <div class="pollText">{{ pollText }}</div>
      <div v-if="!isStatsView">
        <div v-for="(option, index) in options" :key="index" class="pollOption">
          <div class="checkboxContainer">
            <input
              type="checkbox"
              v-model="option.checked"
              @change="dataChanged($event, index)"
            />
            <span class="checkmark"></span>
          </div>
          <div class="optionText">{{ option.text }}</div>
        </div>
      </div>
      <div v-if="isStatsView" class="votesContainer">
        <div class="symposiumVotes">
          <div class="headerText">{{$t('Symposium Votes')}}</div>
          <div class="barContainer" v-for="(option, key) in options" :key="key">
            <div
              class="percentText"
              :style="
                'min-width:' +
                ((option.CoreVotes / totalCoreVotes) * 100).toFixed(2) +
                '%'
              "
            >
              &#x3164;{{ ((option.CoreVotes / totalCoreVotes) * 100).toFixed(2) + "%" }}
            </div>
            <div
              class="bar"
              :style="
                'width:' +
                ((option.CoreVotes / totalCoreVotes) * 100).toFixed(2) +
                '%'
              "
            ></div>
            <div class="barText">{{ option.text }}</div>
          </div>
        </div>
        <div class="extendedVotes">
          <div class="headerText">{{$t('Online Votes')}}</div>
          <div class="barContainer" v-for="(option, key) in options" :key="key">
            <div
              class="percentText"
              :style="
                'min-width:' +
                ((option.ExtendedCoreVotes / totalExtendedVotes) * 100).toFixed(
                  2
                ) +
                '%'
              "
            >
              &#x3164;{{
                ((option.ExtendedCoreVotes / totalExtendedVotes) * 100).toFixed(
                  2
                ) + "%"
              }}
            </div>
            <div
              class="bar"
              :style="
                'width:' +
                ((option.ExtendedCoreVotes / totalExtendedVotes) * 100).toFixed(
                  2
                ) +
                '%'
              "
            ></div>
            <div class="barText">{{ option.text }}</div>
          </div>
        </div>
      </div>
      <div
        class="buttonsContainer"
        :style="reponseUploading == false ? 'display:flex' : 'display:none'"
      >
        <div
          :class="
            options.some((x) => x.checked == true) || InstanceData.allowEmpty
              ? 'submitButton'
              : 'submitButton inactive'
          "
          @click="submitResponse"
          ref="submitButton"
          :style="reponseUploading == false ? 'display:block' : 'display:none'"
          v-if="!isStatsView"
        >
          {{$t('Vote')}}
        </div>
        <div
          v-if="!InstanceData.noSkipButton"
          class="skipButton"
          @click="skipClicked"
          ref="skipButton"
        >
          {{ isStatsView ?$t('Close') : $t('Skip') }}
        </div>
      </div>
      <div
        class="loader submitBtnLoader"
        :style="reponseUploading == true ? 'display:block' : 'display:none'"
      ></div>
      <div class="pollFooter">{{$t('All responses are anonymous')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    InstanceData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dataLoaded: false,
      reponseUploading: false,
      pollNumber: 1,
      pollText: "",
      options: [],
      isActive: false,
      hidden: false,
      videoSwipeStartYPos: 0,
      beforeVideoHiddenVar: false,
      isMobileView: window.innerWidth <= window.mobileWidth,
      isStatsView: false,
      isEmbedded: false
    };
  },
  created() {
    if(this.InstanceData.isEmbedded!=null){
      this.isStatsView=true
      this.isEmbedded=true
      this.isActive = true
      this.setActive();
    }
  },
  mounted() {
    if(!this.InstanceData.isEmbedded){
      this.$refs.videoSwipeContainer.addEventListener(
        "touchstart",
        this.videoSwipeTouchStart
      );
      window.addEventListener("resize", () => {
        this.resize();
      });
    }
  },
  computed: {
    totalCoreVotes() {
      let totalVotes = 0;
      this.options.forEach((vote) => {
        totalVotes += vote.CoreVotes;
      });
      return totalVotes;
    },
    totalExtendedVotes() {
      let totalVotes = 0;
      this.options.forEach((vote) => {
        totalVotes += vote.ExtendedCoreVotes;
      });
      return totalVotes;
    },
  },
  methods: {
    videoSwipeTouchStart(event) {
      if (this.isMobileView) {
        this.videoSwipeStartYPos = event.touches[0].pageY;
        this.$refs.videoSwipeContainer.addEventListener(
          "touchmove",
          this.videoSwipeTouchMove
        );
        this.$refs.videoSwipeContainer.addEventListener(
          "touchend",
          this.videoSwipeTouchEnd
        );
      }
    },
    videoSwipeTouchMove(event) {
      var videoHeight =
        this.$refs.videoSwipeContainer.getBoundingClientRect().height / 2;
      var opacity =
        (this.videoSwipeStartYPos - event.touches[0].pageY) / videoHeight;
      if (opacity > 0) {
        this.$refs.videoSwipeContainer.style.opacity = 1 - opacity;
      }
      if (opacity >= 1) {
        this.beforeVideoHiddenVar = true;
      } else {
        this.beforeVideoHiddenVar = false;
      }
    },
    resize() {
      var newisMobileView = window.innerWidth <= window.mobileWidth;
      this.isMobileView = newisMobileView;
    },
    videoSwipeTouchEnd() {
      if (this.beforeVideoHiddenVar) {
        this.$refs.videoSwipeContainer.style.opacity = 1;
        this.isActive = false;
        this.beforeVideoHiddenVar = false;
        this.skipClicked();
      } else {
        this.$refs.videoControlsAndVideo.style.opacity = 1;
      }
    },
    skipClicked() {
      this.$emit("setChildInactive", this);
    },
    submitResponse() {
      this.reponseUploading = true;
      this.$refs.submitButton.style.pointerEvents = "none";
      let option = this.options.find((x) => x.checked == true);
      fetch(
        this.initialPrefs.pollServerPostData +
          encodeURIComponent(this.InstanceData.pollId) +
          (option != null ? "&responseOptionLabel=" + option.text : "")
      )
        .then((response) => response.json())
        .then((data) => {
          this.pollText = data.poll.question;
          this.options = data.poll.response.map((option) => ({
            checked: false,
            text: option.Text,
            CoreVotes: option.CoreVotes,
            ExtendedCoreVotes: option.ExtendedCoreVotes,
          }));
          this.reponseUploading = false;
          this.$refs.submitButton.style.pointerEvents = "unset";
          this.isStatsView = true
        })
        ;
    },
    setActive() {
      this.dataLoaded = false;
      if (
        this.InstanceData.languages != null &&
        this.InstanceData.languages.length > 0
      ) {
        let quiz = this.InstanceData.languages.find(
          (x) => x.language === this.initialPrefs.curLanguage
        );
        if (quiz != null) {
          this.InstanceData.pollId = quiz.pollId;
        }
      }
      fetch(this.initialPrefs.pollServerGetData + this.InstanceData.pollId)
        .then((response) => response.json())
        .then((data) => {
          let datum = data[0];
          this.pollText = datum.question;
          this.options = datum.response.map((option) => ({
            checked: false,
            text: option.Text,
            CoreVotes: option.CoreVotes,
            ExtendedCoreVotes: option.ExtendedCoreVotes,
          }));
          this.dataLoaded = true;
          if(this.isEmbedded){
            this.$nextTick(() => {
              this.$parent.resize()
            })
          }
        });
      this.isActive = true;
    },
    setInActive() {
      this.isActive = false;
    },
    dataChanged(e, index) {
      if (this.InstanceData.allowMultiple == true) return;
      for (var i = 0; i < this.options.length; i++) {
        if (i != index || e.returnValue == false) {
          this.options[i].checked = false;
        }
      }
    },
  },
};
</script>

<style></style>
